mp.dsgvo = {
    init: function () {
        $('#mpDsgvo a.btn').on('click', mp.dsgvo.click);
        mp.dsgvo.display();
    },

    display: function (ev) {
        if (typeof (Cookies.get('MP_Dsgvo')) === 'undefined') {
            $('#mpDsgvo').show();
        }

        return false;
    },

    click: function (ev) {
        ev.preventDefault();
        var mode = $(this).data('mode')
        $('#mpDsgvo').hide();

        Cookies.set('MP_Dsgvo', mode, {
            expires: 365,
            path: '/',
            domain: '.' + document.location.hostname.replace(/^www\./, ''),
            secure: (location.protocol === 'https:'),
            samesite: (location.protocol === 'https:' ? 'None' : 'Lax')
        });

        if (mode === 'accepted') {
            // Pageimpression nachträglich noch triggern
            try {
                window[disableStr] = false;
                mp.analytics.init();
            } catch (e) {
            }
        }

        return false;
    }
};

$(document).ready(function () {
    mp.dsgvo.init();
});
